import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function NoGames() {
  const { t } = useTranslation();

  return (
    <div className="games_games__no-games">
      <h2 className="games_games__no-games__title">{t("No games yet")}</h2>
      <span className="games_games__no-games__text">
        <p>{t("There are currently no games on this page.")}</p>{" "}
        <Link className="games_games__no-games__link" to={"/"}>
          {t("Return to home")}
        </Link>
      </span>
    </div>
  );
}
